module.exports = "/_next/static/images/UnlockYourFullPotential@2x-63700ae4d3709ea30cb6734c625cf7a9.webp";